export const WS_RECONNECT = {
  MAX_ATTEMPTS: 15,
  BASE_DELAY_MS: 2000,
  MAX_DELAY_MS: 30000,
  RECOVERY_DELAY_MS: 60_000,
  AUTH_RETRY_DELAY_MS: 1000,
};

export function getReconnectDelay(attempt) {
  return Math.min(
    WS_RECONNECT.BASE_DELAY_MS * Math.pow(1.5, attempt - 1),
    WS_RECONNECT.MAX_DELAY_MS,
  );
}

export function isAuthCloseCode(code) {
  return code === 1008 || code === 4001 || code === 4003;
}

export function buildAuthenticatedWsUrl(wsUrl, token) {
  if (!token) return null;
  const separator = wsUrl.includes("?") ? "&" : "?";
  return `${wsUrl}${separator}token=${encodeURIComponent(token)}`;
}

export function respondToServerPing(ws, message) {
  if (!ws || ws.readyState !== WebSocket.OPEN) return;
  if (message?.type !== "PING") return;
  try {
    ws.send(JSON.stringify({ type: "PONG", timestamp: new Date().toISOString() }));
  } catch {
    /* ignore */
  }
}
